// Dependencies
import React from "react";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import Button from "components/buttons/Button/Button.component";

// Helpers
import {
  replaceSlugAndQuery,
  resetInventoryFilter,
} from "helpers/inventory-filters";
import useInventoryFilters from "hooks/inventory/useInventoryFilters.hook";

//  Styles
import { useStyles } from "./ClearAllFiltersButton.styles";

const ClearAllFiltersButton = ({ overrideOnClick, buttonText }) => {
  const classes = useStyles();
  const router = useRouter();
  const { filterCount } = useInventoryFilters();

  const removeAllFilters = () => {
    const { newQuery, newSlug } = resetInventoryFilter(router.query.slug);
    replaceSlugAndQuery(router, newSlug, newQuery);
  };

  return (
    <Button
      variant="text"
      size="lg"
      disabled={!filterCount}
      onClick={overrideOnClick || removeAllFilters}
      className={classes.clearAllFilters}
      data-cy="clear-all-filters"
    >
      {buttonText ?? "Clear all"}
    </Button>
  );
};

ClearAllFiltersButton.propTypes = {
  overrideOnClick: PropTypes.func,
};

ClearAllFiltersButton.defaultProps = {
  overrideOnClick: null,
};

export default ClearAllFiltersButton;
